/**
 * @generated SignedSource<<da37a6cd83abf56fd8fba27ad2e2a42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TOTPCreateInput = {
  clientMutationId?: string | null;
};
export type TotpCreateMutation$variables = {
  input: TOTPCreateInput;
};
export type TotpCreateMutation$data = {
  readonly totpCreate: {
    readonly provisioningUri: string;
    readonly totp: {
      readonly id: string;
    };
  } | null;
};
export type TotpCreateMutation = {
  response: TotpCreateMutation$data;
  variables: TotpCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TOTPCreatePayload",
    "kind": "LinkedField",
    "name": "totpCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provisioningUri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TOTP",
        "kind": "LinkedField",
        "name": "totp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TotpCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TotpCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec94bba988883be94a2aed9d5dfee2ed",
    "id": null,
    "metadata": {},
    "name": "TotpCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TotpCreateMutation(\n  $input: TOTPCreateInput!\n) {\n  totpCreate(input: $input) {\n    provisioningUri\n    totp {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b2520e771570fabaeec73acd40ae79d";

export default node;
